import React from 'react';
import {
  Car,
  Coffee,
  Factory,
  Heart,
  Package,
  Plane,
  Shirt,
  ShoppingBag,
  Truck,
  Wrench,
} from 'lucide-react';

const industries = [
  {
    name: 'Manufacturing',
    description: 'Unify production planning, quality management, and supply chain operations with Infor OS integration and automation capabilities.',
    icon: Factory,
    color: '#FF4A3D',
    bgColor: '#FFF1EE',
  },
  {
    name: 'Distribution',
    description: 'Streamline order fulfillment, inventory visibility, and logistics coordination with real-time data integration across the supply chain.',
    icon: Package,
    color: '#F97316',
    bgColor: '#FFF4ED',
  },
  {
    name: 'Food & Beverage',
    description: 'Ensure food safety compliance, traceability, and quality control with automated workflows and real-time monitoring capabilities.',
    icon: Coffee,
    color: '#DC2626',
    bgColor: '#FEF2F2',
  },
  {
    name: 'Automotive',
    description: 'Manage complex supply chains, just-in-time delivery, and regulatory compliance with integrated platform capabilities.',
    icon: Car,
    color: '#2563EB',
    bgColor: '#EFF6FF',
  },
  {
    name: 'Aerospace & Defense',
    description: 'Maintain strict compliance, traceability, and quality standards with secure, integrated digital platforms.',
    icon: Plane,
    color: '#7C3AED',
    bgColor: '#F5F3FF',
  },
  {
    name: 'Industrial Equipment',
    description: 'Optimize aftermarket service, equipment maintenance, and supply chain visibility with unified digital solutions.',
    icon: Wrench,
    color: '#059669',
    bgColor: '#ECFDF5',
  },
  {
    name: 'Fashion & Apparel',
    description: 'Manage seasonal collections, omnichannel fulfillment, and global supply chains with agile platform capabilities.',
    icon: Shirt,
    color: '#EC4899',
    bgColor: '#FDF2F8',
  },
  {
    name: 'Healthcare',
    description: 'Ensure regulatory compliance, patient data security, and supply chain integrity with robust platform controls.',
    icon: Heart,
    color: '#EF4444',
    bgColor: '#FEF2F2',
  },
  {
    name: 'Retail',
    description: 'Enable omnichannel commerce, real-time inventory visibility, and personalized customer experiences with integrated solutions.',
    icon: ShoppingBag,
    color: '#F59E0B',
    bgColor: '#FFFBEB',
  },
  {
    name: 'Logistics & Supply Chain',
    description: 'Optimize transportation, warehouse operations, and end-to-end supply chain visibility with real-time data integration.',
    icon: Truck,
    color: '#0891B2',
    bgColor: '#ECFEFF',
  },
];

const IndustryCard = ({ industry }) => {
  const Icon = industry.icon;

  return (
    <article
      className="group flex h-full min-w-0 flex-col rounded-2xl border bg-white p-6 transition duration-300 hover:-translate-y-1 hover:shadow-lg"
      style={{
        borderColor: '#E2E8F0',
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
      }}
    >
      <div
        className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl transition duration-300 group-hover:scale-105"
        style={{ backgroundColor: industry.bgColor, color: industry.color }}
      >
        <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.8} />
      </div>

      <h3 className="mb-3 text-lg font-bold leading-snug" style={{ color: '#1A2634' }}>
        {industry.name}
      </h3>

      <p className="text-sm font-medium leading-6" style={{ color: '#334155', textAlign: 'left' }}>
        {industry.description}
      </p>
    </article>
  );
};

const InforOSIndustries = () => {
  return (
    <section
      aria-labelledby="infor-os-industries-title"
      className="px-4 py-14 sm:px-6 lg:px-8 lg:py-20"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="mx-auto w-full max-w-7xl">
        <h2
          id="infor-os-industries-title"
          className="mb-10 text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl"
          style={{ color: '#1A2634' }}
        >
          Industries We Support
        </h2>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {industries.map((industry) => (
            <IndustryCard key={industry.name} industry={industry} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default InforOSIndustries;
